angular.module('bmsApp.resource').controller('TemporalResourceUploadModalCtrl', TemporalResourceUploadModalCtrl);

TemporalResourceUploadModalCtrl.$inject = [
	'$scope',
	'$modalInstance',
	'ConfigService',
	'resourceOrFile',
	'type',
];

function TemporalResourceUploadModalCtrl(
	$scope,
	$modalInstance,
	ConfigService,
	resourceOrFile,
	type,
) {
	let self = this;
	let handlers = {};

	angular.extend(self, {
		handlers: handlers,
		loading: false,
		resourceOrFile: resourceOrFile,
		type: type,
		form: {
			validator: {
				config: {},
				api: {}
			},
			hasErrors: false,
			// errors: [],
			processing: false,
			data: {
				startDate: null,
				endDate: null,
			},
		},
	});

	$scope.config = ConfigService.config;

	$scope.datePickerConfig = angular.extend(angular.copy($scope.config.datePicker.basic), {
		options: angular.extend(angular.copy($scope.config.datePicker.basic.options), {
			parentEl: '.modal-content'
		})
	});
	
	$scope.datePickerConfig = angular.extend(angular.copy($scope.config.datePicker.basic), {
		storageFormat: 'YYYY-MM-DD',
		options: angular.extend(angular.copy($scope.config.datePicker.basic.options), {
			format: 'MMMM Do YYYY',
			parentEl: '.modal-content'
		})
	});

	if (self.type === 'resource') {
		self.form.data.startDate = moment.utc(self.resourceOrFile.starts_at);
		self.form.data.endDate = moment.utc(self.resourceOrFile.ends_at);
		self.filename = resourceOrFile.file.label;
	} else {
		self.filename = resourceOrFile.name;
	}

	handlers.formSubmitted = (form) => {
		if (form.$valid) {
			self.form.hasErrors = false;
			if (moment.utc(self.form.data.endDate).isBefore(moment.utc(self.form.data.startDate))) {
				self.form.hasErrors = true;
				self.form.errors = [];
				self.form.errors.push('End date must be after the start date');
			} else {
				$modalInstance.close({startDate: moment.utc(self.form.data.startDate), endDate: moment.utc(self.form.data.endDate)});
			}
		}
		else {
			self.form.hasErrors = true;
		}
	};

	handlers.closeDialogClick = () => {
		$modalInstance.dismiss('cancel');
	};
}